import { render, staticRenderFns } from "./Damaged_stock.vue?vue&type=template&id=27a27319&scoped=true&"
import script from "./Damaged_stock.vue?vue&type=script&lang=js&"
export * from "./Damaged_stock.vue?vue&type=script&lang=js&"
import style0 from "./Damaged_stock.vue?vue&type=style&index=0&id=27a27319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a27319",
  null
  
)

export default component.exports